const ROLE_LABELS = {
  PLATFORM_SUPER_ADMIN: 'PREIKA緊急最高管理者',
  PLATFORM_OPERATIONS_ADMIN: 'PREIKA運営管理者',
  PLATFORM_SUPPORT_VIEWER: 'PREIKAサポート閲覧者',
  TENANT_OWNER: '契約企業管理者（自社最上位）',
  TENANT_SYSTEM_ADMIN: '社内システム管理者',
  EXECUTIVE_ADMIN: '経営管理者',
  CLERK: '事務担当者',
  EMPLOYEE: '一般社員'
}

function value (item, ...keys) {
  for (const key of keys) {
    if (item && Object.prototype.hasOwnProperty.call(item, key)) return item[key]
    const upper = key.toUpperCase()
    if (item && Object.prototype.hasOwnProperty.call(item, upper)) return item[upper]
  }
  return null
}

export function normalizeRoles (items) {
  if (!Array.isArray(items)) return []
  return items.map(item => {
    const code = value(item, 'roleCode', 'role_code')
    const name = value(item, 'roleName', 'role_name')
    return {
      id: value(item, 'id'),
      code,
      name: ROLE_LABELS[code] || name || '名称未設定の役割',
      description: value(item, 'description') || '',
      displayOrder: Number(value(item, 'displayOrder', 'display_order') || 9999)
    }
  }).filter(role => role.id != null)
    .sort((left, right) => left.displayOrder - right.displayOrder)
}

export function defaultRoleIds (roles) {
  const employee = roles.find(role => role.code === 'EMPLOYEE')
  return employee ? [employee.id] : []
}

export function roleNames (roles, selectedIds) {
  const selected = new Set((selectedIds || []).map(value => String(value)))
  return roles.filter(role => selected.has(String(role.id))).map(role => role.name)
}

export function toggleRoleId (selectedIds, roleId, checked) {
  const next = Array.isArray(selectedIds) ? selectedIds.slice() : []
  const index = next.findIndex(value => String(value) === String(roleId))
  if (checked && index < 0) next.push(roleId)
  if (!checked && index >= 0) next.splice(index, 1)
  return next
}
